<brightside-web-required-legal-documents
  *ngIf="documentsKey"
  [documentsKey]="documentsKey"
  (termsSubmittedEvent)="termsAccepted($event)"
  [showCloseButton]="true"
  [showBackbutton]="false"
  (closeButtonEvent)="goToHome()"
>
</brightside-web-required-legal-documents>
